import React, { useEffect, useState } from "react";
import ItemLists from "../ItemLists/ItemLists";
import { getUserEmail } from "../../../utils/auth";
import BASE_URL from "../../../config/apiConfig";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./UserHome.scss";

function Home() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const email = getUserEmail();

        const response = await axios.post(
          `${BASE_URL}/api/payment/getTransactions`,
          { email },
        );

        if (response.data.transactions.length === 0) {
          setError(
            "You don't have any active subscriptions. Please check our plans.",
          );
        } else {
          setTransactions(response.data.transactions);
        }
      } catch (err) {
        console.error("Failed to fetch transactions:", err);
        setError("Failed to fetch transactions. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  return (
    <main className="farmology-user-home">
      <section className="farmology-home-header">
        <div className="farmology-home-header-inner">
          <div>
            <span className="farmology-home-eyebrow">FARMOLOGY PLATFORM</span>
            <h1>Your farm, at a glance.</h1>
            <p>
              Manage your farms, explore crop intelligence and keep your
              agricultural decisions connected in one place.
            </p>
          </div>

          <div className="farmology-home-status">
            <span className="farmology-home-status-dot" />
            <span>Farm intelligence</span>
          </div>
        </div>
      </section>

      <section className="farmology-home-content">
        <div className="farmology-home-section-heading">
          <div>
            <span className="farmology-home-section-eyebrow">
              YOUR FARM DATA
            </span>
            <h2>Manage your farms</h2>
          </div>
          <p>
            Access your farm records and crop-specific information from your
            dashboard.
          </p>
        </div>

        <div className="farmology-home-items">
          <ItemLists type="farms" />
          <ItemLists type="plantation_crop_farms" />
          <ItemLists type="field_crop_farms" />
        </div>

        {loading ? (
          <div className="farmology-home-loading" aria-live="polite">
            <div className="farmology-home-loader" />
            <span>Loading your farm data...</span>
          </div>
        ) : error ? (
          <div className="farmology-home-empty">
            <div className="farmology-home-empty-card">
              <div className="farmology-home-empty-icon">+</div>

              <span className="farmology-home-section-eyebrow">
                GET STARTED
              </span>

              <h2>Discover our plans</h2>

              <p>{error}</p>

              <p className="farmology-home-empty-description">
                Choose a plan that fits your farm and unlock the intelligence
                and tools available across the Farmology platform.
              </p>

              <button
                type="button"
                className="farmology-home-plans-button"
                onClick={() => navigate("/pricing")}
              >
                Explore Plans
                <span>↗</span>
              </button>
            </div>
          </div>
        ) : null}
      </section>
    </main>
  );
}

export default Home;
